var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAi = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454BD1",
    d: "M17.51.969H2.191c-.83 0-1.505.679-1.505 1.515v10.53h2.005V2.989h14.316V17.4H7.205v2.02H17.51c.829 0 1.505-.681 1.505-1.516V2.484c0-.836-.676-1.515-1.505-1.515z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#454BD1",
    d: "m10.225 13.536-.522-1.469H6.946l-.521 1.47H4.71l2.938-7.289H9l2.938 7.288zM8.318 8.154l-.915 2.594h1.831zM12.633 13.536V6.248h1.596v7.288z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D65B31",
    d: "M5.198 15.033v5.032H3.304a.324.324 0 0 1-.324-.326v-2.661H.263a.32.32 0 0 1-.251-.316v-1.73h5.186"
  })));
};
export default SvgAi;